<div class="container">
  <label>{{'point_cloud_size' | transloco}}: x{{slider.value}}</label>
  <div class="slide">
    <label style="padding-right: 5px">x{{pointSizeMin}}</label>
    <mat-slider min="{{pointSizeMin}}" max="{{pointSizeMax}}" step="1" class="slider">
      <input matSliderThumb
             #slider
             [value]="(pointSize$ | async)"
             (valueChange)="onSliderChange($event)">
    </mat-slider>
    <label style="padding-left: 5px">x{{pointSizeMax}}</label>
  </div>
</div>

